import { RouteConfig } from 'vue-router'
const ProcessEvaluation = () => import('../views/pe-class-big-recess/ProcessEvaluation.vue')
const PEClassScheduleList = () => import('../views/pe-class-big-recess/PEClassScheduleList.vue')
const PEClassEvaluationDetail = () => import('../views/pe-class-big-recess/PEClassEvaluationDetail.vue')

const DataStatisticsPage = () => import('../views/pe-class-big-recess/DataStatistics.vue')
const AnalysisReportPage = () => import('../views/pe-class-big-recess/AnalysisReport.vue')

const DataStatisticsClazzDetail = () => import('../views/pe-class-big-recess/DataStatisticsClazzDetail.vue')

const DataStatisticsStudentDetail = () => import('../views/pe-class-big-recess/DataStatisticsStudentDetail.vue')

const PEClassBigBreak = () => import('../views/pe-class-big-recess/PEClassBigBreak.vue')

export const peClassBigBreakRoute: RouteConfig = {
  path: 'pe-class-big-recess-attendance',
  name: 'pe_class_big_recess_attendance',
  component: PEClassBigBreak,
  meta: {
    title: '大课间出勤',
  },
}

export const peClassScheduleListRoute: RouteConfig = {
  path: '/pe-class-big-recess-schedule-list',
  name: 'pe_class_big_recess_schedule_list',
  component: PEClassScheduleList,
  meta: {
    title: '课程表',
  },
}

export const PEClassEvaluationDetailRoute: RouteConfig = {
  path: '/pe-class-big-recess-evaluation-detail',
  name: 'pe_class_big_recess_evaluation_detail',
  component: PEClassEvaluationDetail,
  props: (route) => ({ ...route.query, ...route.params, lesson: JSON.parse(route.query.lesson as string) }),

  meta: {
    title: '评价情况',
  },
}
export const dataStatisticsRoute: RouteConfig = {
  path: '/big-recess-data-statistics',
  name: 'big_recess_data_statistics',
  component: DataStatisticsPage,
  meta: {
    title: '大课间出勤',
  },
}

export const dataStatisticsClazzDetailRouter: RouteConfig = {
  path: '/big-recess-data-statistics-clazz-detail',
  name: 'big_recess_data_statistics_clazz_detail',
  component: DataStatisticsClazzDetail,
  props: (route) => ({ ...route.query, ...route.params, semesters: JSON.parse(route.query.semesters as string) }),

  meta: {
    title: '班级详情',
  },
}

export const dataStatisticsStudentDetailRouter: RouteConfig = {
  path: '/big-recess-data-statistics-student-detail',
  name: 'big_recess_data_statistics_student_detail',
  component: DataStatisticsStudentDetail,
  props: (route) => ({ ...route.query, ...route.params, semesters: JSON.parse(route.query.semester as string) }),

  meta: {
    title: '学生详情',
  },
}

export const analysisReportRoute: RouteConfig = {
  path: 'big-recess-analysis-report',
  name: 'big_recess_analysis_report',
  component: AnalysisReportPage,
  meta: {
    title: '体育课出勤',
  },
}

export const processEvaluationRoute: RouteConfig = {
  path: '/pe-class-big-recess',
  name: 'pe_class_big_recess',
  redirect: '/pe-class-big-recess/pe-class-big-recess-evaluation',
  component: ProcessEvaluation,
  children: [dataStatisticsRoute, analysisReportRoute, peClassBigBreakRoute],
}

export default [
  processEvaluationRoute,
  peClassScheduleListRoute,
  PEClassEvaluationDetailRoute,
  dataStatisticsClazzDetailRouter,
  dataStatisticsStudentDetailRouter,
]
